(() => {
  const getSelectedOptions = (picker) => {
    return Array.from(picker.querySelectorAll('fieldset, .product-form__input')).map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      const select = group.querySelector('select');
      return select ? select.value : null;
    }).filter(Boolean);
  };

  const findSelectedVariant = (picker) => {
    const json = picker.querySelector('script[type="application/json"]');
    if (!json) return null;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (_) { return null; }
    const selected = getSelectedOptions(picker);
    return variants.find((variant) => variant.options.every((value, index) => value === selected[index])) || null;
  };

  const updateGallery = (picker) => {
    const variant = findSelectedVariant(picker);
    const mediaId = variant?.featured_media?.id;
    if (!mediaId) return;

    const sectionId = picker.dataset.section;
    const productInfo = picker.closest('product-info') || document.getElementById(`ProductInfo-${sectionId}`);
    const gallery = productInfo?.querySelector('media-gallery') || document.querySelector(`media-gallery[data-section="${sectionId}"]`);
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    gallery.setActiveMedia(`${sectionId}-${mediaId}`, true);
  };

  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects');
    if (!picker) return;
    window.requestAnimationFrame(() => updateGallery(picker));
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('variant-selects').forEach(updateGallery);
  });
})();
